module.exports = __webpack_public_path__ + "static/assets/578cb2e6df722f86b9fe84daa5e01e34.png";